import { compose, propEq, find } from 'ramda'

export const getVideoDoneThreshold = compose(
  option => parseFloat(option.value),
  find(propEq('key', 'PLAYER_VIDEO_DONE_THRESHOLD'))
)
